import React, { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { FaUsers, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./Customers.css";

// Customer logos
import customer1 from "../../Assets/asian_island.jpeg";
import customer2 from "../../Assets/boolmax_ceylon.jpeg";
import customer3 from "../../Assets/aspa_japanese.png";
import customer4 from "../../Assets/beyond_australian.jpeg";
import customer5 from "../../Assets/hyperplex.jpg";
import customer6 from "../../Assets/ccpl.jpeg";
import customer7 from "../../Assets/coco_glam.jpeg";
import customer8 from "../../Assets/coullax.jpeg";
import customer9 from "../../Assets/direct_computers.png";
import customer10 from "../../Assets/infinity.jpeg";
import customer11 from "../../Assets/International Airline & Aviation Collage (PVT.) Ltd..png";
import customer12 from "../../Assets/Exclusive-Travels-Pvt-Ltd.webp";
import customer13 from "../../Assets/JL Bungalow.png";
import customer14 from "../../Assets/Nelna farm.jpeg";
import customer15 from "../../Assets/samanala.jpeg";
import customer16 from "../../Assets/kalana weta .png";
import customer17 from "../../Assets/Pothak.lk.png";
import customer18 from "../../Assets/Premium Coir .png";
import customer19 from "../../Assets/Tharindu Farm.jpeg";
import customer20 from "../../Assets/Orient Glass.jpeg";

const customerLogos = [
  customer1, customer2, customer3, customer4, customer5,
  customer6, customer7, customer8, customer9, customer10,
  customer11, customer12, customer13, customer14, customer15,
  customer16, customer17, customer18, customer19, customer20
];

const Customers = () => {
  const scrollContainerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const checkScroll = () => {
    const container = scrollContainerRef.current;
    if (container) {
      setShowLeftArrow(container.scrollLeft > 0);
      setShowRightArrow(
        container.scrollLeft < container.scrollWidth - container.clientWidth - 10
      );
    }
  };

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = 300;
      container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
      setTimeout(checkScroll, 300);
    }
  };

  return (
    <div className="customers-page">
      <h1 className="customers-title">Our Valued Customers</h1>

      {/* ===== Summary Section with Carousel ===== */}
      <div className="customer-summary">
        <div className="carousel-container">
          {/* Left Arrow */}
          {showLeftArrow && (
            <button
              onClick={() => scroll('left')}
              className="carousel-arrow carousel-arrow-left"
              aria-label="Scroll left"
            >
              <FaChevronLeft />
            </button>
          )}

          {/* Scrollable Container */}
          <div
            ref={scrollContainerRef}
            onScroll={checkScroll}
            className="summary-scroll-container"
          >
            <div className="summary-boxes-wrapper">
              <div className="summary-box">
                <FaUsers className="summary-icon" />
                <h4>Proprietors</h4>
                <p>40+</p>
              </div>

              <div className="summary-box">
                <FaUsers className="summary-icon" />
                <h4>Partnerships</h4>
                <p>15+</p>
              </div>

              <div className="summary-box">
                <FaUsers className="summary-icon" />
                <h4>Companies</h4>
                <p>86+</p>
              </div>

              <div className="summary-box">
                <FaUsers className="summary-icon" />
                <h4>Government</h4>
                <p>5+</p>
              </div>
              
            </div>
          </div>

          {/* Right Arrow */}
          {showRightArrow && (
            <button
              onClick={() => scroll('right')}
              className="carousel-arrow carousel-arrow-right"
              aria-label="Scroll right"
            >
              <FaChevronRight />
            </button>
          )}
        </div>
      </div>

      {/* ===== Logos Grid ===== */}
      <div className="customers-logos">
        <Row className="justify-content-center g-4">
          {customerLogos.map((logo, index) => (
            <Col
              key={index}
              xs={6}
              sm={4}
              md={3}
              lg={2}
              className="text-center"
            >
              <img
                src={logo}
                alt="Customer logo"
                className="customer-logo"
                loading="lazy"
              />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default Customers;